export default __webpack_public_path__ + "static/media/Look at me IV.58463ade.jpg";